<template>
  <div class="half-page" v-if="visible">
    <div class="half-page__box">
      <div class="half-page__box__close" @click="onClose"></div>
      <div class="half-page__box__title" v-if="title">
        <div class="half-page__box__left"></div>
        {{ title }}
        <div class="half-page__box__right"></div>
      </div>
      <slot name="body"></slot>
    </div>
    <div class="half-page__mask"></div>
  </div>
</template>

<script>
import { fixScrollDeep, resetDocumentScroll } from '@/common/utils';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(value) {
      if (value) {
        fixScrollDeep();
      }
    }
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('onClose');
      resetDocumentScroll();
    }
  }
};
</script>
<style scoped lang="less">
@import '../../../styles/fn.less';
.half-page {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  &__box {
    width: 100%;
    background-color: #fff;
    height: auto;
    position: relative;
    border-radius: 0.3rem 0.3rem 0 0;
    z-index: 1;
    &__title {
      font-family: PingFangSC-Semibold;
      font-size: 0.36rem;
      width: 100%;
      text-align: center;
      padding: 0.36rem 0;
      color: #1176d1;
      letter-spacing: 0;
      font-weight: 600;
      line-height: 0.5rem;
      background: #eef8fe;
      border-radius: 0.3rem 0.3rem 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__left {
      width: 0.2rem;
      height: 0.03rem;
      background-image: linear-gradient(270deg, #1176d1 0%, #ffffff 100%);
      border-radius: 0.015rem;
      margin-right: 0.17rem;
    }
    &__right {
      width: 0.2rem;
      height: 0.03rem;
      background-image: linear-gradient(270deg, #ffffff 0%, #1176d1 100%);
      border-radius: 0.015rem;
      margin-left: 0.17rem;
    }
    &__close {
      z-index: 999;
      position: absolute;
      right: 0.21rem;
      top: -0.87rem;
      transform: translateX(-50%);
      .block-image(
        0.65rem,
        0.65rem,
        'https://p0.meituan.net/wxapp/55e0960f39ef24f37febba347446d4421265.png'
      );
    }
  }
  &__mask {
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}
</style>
